import {useMutation, useQuery} from "react-query";
import axios from "axios";
import {useSnackbar} from "notistack";

interface ResponseConfigurationUserAssociation {
    message: string;
    data: [
        {
            id: number,
            name: string,
            email: string,
            isAssociated: boolean
        }
    ]
}

interface BulkAssociateUsersDTO {
    authorityGroupId: number;
    userList: Array<number>;
}

const fetchUsersByAuthorityGroup = async (authorityGroupId: number) => {
    try {
        return await axios.get<ResponseConfigurationUserAssociation>(
            `api/user-authority-groups/${authorityGroupId}/users`,
            {
                timeout: 30000,
            }
        ).then((res) => res.data);
    } catch (error) {
        console.error("Error fetching users:", error);
        return Promise.reject(error);
    }
};

export const UsersAssociationReactQuery = (authorityGroupId: number, enabled: boolean) => {
    return useQuery(
        ["users-profile-association", authorityGroupId, enabled],
        () => fetchUsersByAuthorityGroup(authorityGroupId),
        {
            enabled: !!authorityGroupId && enabled,
            staleTime: 0,
            refetchOnMount: "always",
        }
    );
};

const bulkAssociateUsers = async (data: BulkAssociateUsersDTO) => {
    try {
        return await axios.post(
            `api/user-authority-groups/bulk-associate-users`,
            data,
            { timeout: 30000 }
        );
    } catch (error) {
        console.error("Error associating users to profile:", error);
        return Promise.reject(error);
    }
};

export const AssociateUsersToProfileReactQuery = () => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation(bulkAssociateUsers, {
        onSuccess: () => {
            enqueueSnackbar("Associação de usuários feita com sucesso.", {
                variant: "success",
                anchorOrigin: { vertical: "bottom", horizontal: "right" },
            });
        },
        onError: (error: any) => {
            enqueueSnackbar(`Não foi possível concluir a operação, tente novamente. ${error.message}`, {
                variant: "error",
                anchorOrigin: { vertical: "bottom", horizontal: "right" },
            });
        },
    });
};